// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var BrowserStyle = require("../BrowserStyle.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var BrowserComponents_FlexColumn = require("./BrowserComponents_FlexColumn.bs.js");
var ReactFontawesome = require("@fortawesome/react-fontawesome");
var BrowserBindings_FontAwesomeIcon = require("../bindings/BrowserBindings_FontAwesomeIcon.bs.js");
var FreeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");

var defaultColor = {
  TAG: /* Grey */2,
  _0: /* Lightest */4
};

var container = Curry._1(BrowserStyle.style, BrowserStyle.withFont(undefined, undefined, /* Large */4, undefined)({
          hd: BrowserStyle.display(BrowserStyle.flexBox),
          tl: {
            hd: BrowserStyle.flexDirection(BrowserStyle.row),
            tl: {
              hd: BrowserStyle.flexWrap(BrowserStyle.nowrap),
              tl: {
                hd: BrowserStyle.alignItems(BrowserStyle.center),
                tl: {
                  hd: BrowserStyle.justifyContent(BrowserStyle.center),
                  tl: {
                    hd: BrowserStyle.color(defaultColor),
                    tl: {
                      hd: BrowserStyle.textAlign(BrowserStyle.center),
                      tl: {
                        hd: BrowserStyle.height(BrowserStyle.pct(100.0)),
                        tl: {
                          hd: BrowserStyle.margin(BrowserStyle.rem(1.75)),
                          tl: /* [] */0
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }));

var spinKeyframes = Curry._1(BrowserStyle.keyframes, {
      hd: [
        0,
        {
          hd: BrowserStyle.transform(BrowserStyle.scale(0.75, 0.75)),
          tl: {
            hd: BrowserStyle.color(defaultColor),
            tl: /* [] */0
          }
        }
      ],
      tl: {
        hd: [
          20,
          {
            hd: BrowserStyle.transform(BrowserStyle.scale(1.0, 1.0)),
            tl: {
              hd: BrowserStyle.color({
                    TAG: /* Blue */0,
                    _0: /* Medium */2
                  }),
              tl: /* [] */0
            }
          }
        ],
        tl: {
          hd: [
            50,
            {
              hd: BrowserStyle.transform(BrowserStyle.scale(0.75, 0.75)),
              tl: {
                hd: BrowserStyle.color(defaultColor),
                tl: /* [] */0
              }
            }
          ],
          tl: {
            hd: [
              100,
              {
                hd: BrowserStyle.transform(BrowserStyle.scale(0.75, 0.75)),
                tl: {
                  hd: BrowserStyle.color(defaultColor),
                  tl: /* [] */0
                }
              }
            ],
            tl: /* [] */0
          }
        }
      }
    });

function getDot(delay) {
  return Curry._1(BrowserStyle.style, {
              hd: BrowserStyle.animationName(spinKeyframes),
              tl: {
                hd: BrowserStyle.animationDuration(1200),
                tl: {
                  hd: BrowserStyle.animationDelay(delay),
                  tl: {
                    hd: BrowserStyle.animationIterationCount(BrowserStyle.infinite),
                    tl: {
                      hd: BrowserStyle.animationTimingFunction(BrowserStyle.easeInOut),
                      tl: {
                        hd: BrowserStyle.transform(BrowserStyle.scale(0.75, 0.75)),
                        tl: {
                          hd: BrowserStyle.marginRight(BrowserStyle.rem(0.25)),
                          tl: /* [] */0
                        }
                      }
                    }
                  }
                }
              }
            });
}

var firstDot = getDot(0);

var secondDot = getDot(400);

var thirdDot = getDot(800);

var Styles = {
  defaultColor: defaultColor,
  container: container,
  spinKeyframes: spinKeyframes,
  getDot: getDot,
  firstDot: firstDot,
  secondDot: secondDot,
  thirdDot: thirdDot
};

function BrowserComponents_Loading$Base(Props) {
  var className = Props.className;
  return React.createElement("div", {
              className: BrowserStyle.Utils.extendBaseStyle(container, className)
            }, React.createElement((function (prim) {
                    return ReactFontawesome.FontAwesomeIcon(prim);
                  }), Curry._8(BrowserBindings_FontAwesomeIcon.makeProps(firstDot, undefined, undefined, undefined)(undefined), undefined, FreeSolidSvgIcons.faCircle, undefined, undefined, undefined, undefined, undefined, undefined)), React.createElement((function (prim) {
                    return ReactFontawesome.FontAwesomeIcon(prim);
                  }), Curry._8(BrowserBindings_FontAwesomeIcon.makeProps(secondDot, undefined, undefined, undefined)(undefined), undefined, FreeSolidSvgIcons.faCircle, undefined, undefined, undefined, undefined, undefined, undefined)), React.createElement((function (prim) {
                    return ReactFontawesome.FontAwesomeIcon(prim);
                  }), Curry._8(BrowserBindings_FontAwesomeIcon.makeProps(thirdDot, undefined, undefined, undefined)(undefined), undefined, FreeSolidSvgIcons.faCircle, undefined, undefined, undefined, undefined, undefined, undefined)));
}

var Base = {
  Styles: Styles,
  make: BrowserComponents_Loading$Base
};

var container$1 = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.margin(BrowserStyle.zero),
      tl: /* [] */0
    });

var Styles$1 = {
  container: container$1
};

function BrowserComponents_Loading$Compact(Props) {
  var className = Props.className;
  return React.createElement(BrowserComponents_Loading$Base, {
              className: BrowserStyle.Utils.extendBaseStyle(container$1, className)
            });
}

var Compact = {
  Styles: Styles$1,
  make: BrowserComponents_Loading$Compact
};

var container$2 = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignItems(BrowserStyle.center),
      tl: {
        hd: BrowserStyle.flex({
              NAME: "num",
              VAL: 1.0
            }),
        tl: {
          hd: BrowserStyle.height(BrowserStyle.vh(100.0)),
          tl: {
            hd: BrowserStyle.justifyContent(BrowserStyle.center),
            tl: /* [] */0
          }
        }
      }
    });

var Styles$2 = {
  container: container$2
};

function BrowserComponents_Loading$Screen(Props) {
  return React.createElement(BrowserComponents_FlexColumn.make, {
              className: container$2,
              children: React.createElement(BrowserComponents_Loading$Base, {})
            });
}

var $$Screen = {
  Styles: Styles$2,
  make: BrowserComponents_Loading$Screen
};

var spinnerKeyframes = Curry._1(BrowserStyle.keyframes, {
      hd: [
        0,
        {
          hd: BrowserStyle.transform({
                NAME: "rotate",
                VAL: {
                  NAME: "turn",
                  VAL: 0.0
                }
              }),
          tl: /* [] */0
        }
      ],
      tl: {
        hd: [
          100,
          {
            hd: BrowserStyle.transform({
                  NAME: "rotate",
                  VAL: {
                    NAME: "turn",
                    VAL: 1.0
                  }
                }),
            tl: /* [] */0
          }
        ],
        tl: /* [] */0
      }
    });

function spinner(spinnerColor) {
  return Curry._1(BrowserStyle.merge, {
              hd: Curry._1(BrowserStyle.style, {
                    hd: BrowserStyle.after({
                          hd: BrowserStyle.animationDelay(0),
                          tl: {
                            hd: BrowserStyle.animationDuration(1200),
                            tl: {
                              hd: BrowserStyle.animationIterationCount(BrowserStyle.infinite),
                              tl: {
                                hd: BrowserStyle.animationName(spinnerKeyframes),
                                tl: {
                                  hd: BrowserStyle.animationTimingFunction(BrowserStyle.easeInOut),
                                  tl: {
                                    hd: BrowserStyle.border(BrowserStyle.Spacing.xSmall, BrowserStyle.solid, /* Transparent */2),
                                    tl: {
                                      hd: BrowserStyle.borderRadius(BrowserStyle.pct(50.0)),
                                      tl: {
                                        hd: BrowserStyle.borderTopColor(Relude_Option.getOrElse({
                                                  TAG: /* Teal */6,
                                                  _0: /* Medium */2
                                                }, spinnerColor)),
                                        tl: {
                                          hd: BrowserStyle.bottom(BrowserStyle.zero),
                                          tl: {
                                            hd: BrowserStyle.contentRule({
                                                  NAME: "text",
                                                  VAL: ""
                                                }),
                                            tl: {
                                              hd: BrowserStyle.height(BrowserStyle.Spacing.medium),
                                              tl: {
                                                hd: BrowserStyle.left(BrowserStyle.zero),
                                                tl: {
                                                  hd: BrowserStyle.margin(BrowserStyle.auto),
                                                  tl: {
                                                    hd: BrowserStyle.position(BrowserStyle.absolute),
                                                    tl: {
                                                      hd: BrowserStyle.right(BrowserStyle.zero),
                                                      tl: {
                                                        hd: BrowserStyle.top(BrowserStyle.zero),
                                                        tl: {
                                                          hd: BrowserStyle.width(BrowserStyle.Spacing.medium),
                                                          tl: /* [] */0
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }),
                    tl: {
                      hd: BrowserStyle.padding(BrowserStyle.rem(0.75)),
                      tl: {
                        hd: BrowserStyle.position(BrowserStyle.relative),
                        tl: {
                          hd: BrowserStyle.maxWidth(BrowserStyle.zero),
                          tl: /* [] */0
                        }
                      }
                    }
                  }),
              tl: /* [] */0
            });
}

var Styles$3 = {
  spinnerKeyframes: spinnerKeyframes,
  spinner: spinner
};

function BrowserComponents_Loading$Spinner(Props) {
  var color = Props.color;
  var className = Props.className;
  return React.createElement("span", {
              className: BrowserStyle.Utils.extendBaseStyle(spinner(color), className)
            });
}

var Spinner = {
  Styles: Styles$3,
  make: BrowserComponents_Loading$Spinner
};

var make = BrowserComponents_Loading$Base;

exports.Base = Base;
exports.Compact = Compact;
exports.$$Screen = $$Screen;
exports.Spinner = Spinner;
exports.Styles = Styles;
exports.make = make;
/* container Not a pure module */
